<template>
  <div id="footer">
    <div class="tab" @click="back">
      <svgicon src="svg/back-circle.svg" :width=25 :height=25></svgicon>
      {{ $t("navigation.back") }}
    </div>
    <router-link class="tab" to="/billboard" v-if="User.token">
      <svgicon src="svg/news.svg" :width=25 :height=25></svgicon>
      {{ $t("page.billboard") }}
    </router-link>
    <router-link class="tab" to="/home">
      <svgicon src="svg/home.svg" :width=25 :height=25></svgicon>
      {{ $t("page.home") }}
    </router-link>
    <router-link class="tab" to="/services">
      <svgicon src="svg/services.svg" :width=25 :height=25></svgicon>
      {{ $t("page.services") }}
    </router-link>
    <router-link class="tab" to="/requests" v-if="User.token && RequestCategories && RequestCategories.categories.length > 0">
      <svgicon src="svg/history.svg" :width=25 :height=25></svgicon>
      {{ $t("page.requests") }}
    </router-link>
    <router-link class="tab" to="/about" v-if="!User.token">
      <svgicon src="svg/humaniti.svg" v-if="!$store.state.cogir" :width=25 :height=25></svgicon>
      <img src="@/assets/img/icons/octo.png" class="cogir" v-if="$store.state.cogir" height="25">
      <img src="@/assets/img/icons/octo-green.png" class="cogir active" v-if="$store.state.cogir" height="25">
      {{ $t("page.about") }}
    </router-link>
  </div>
</template>

<script>

  import User from '../../core/User';
  import RequestCategories from "../../core/RequestCategories";

  export default {

    name: "footerComponent",

    data() {
      return {
        User,
        RequestCategories
      }
    },

    methods: {
      back() {
        window.history.back();
      }
    }

  }

</script>

<style lang="scss" scoped>

  #footer {
    height: 60px;
    background-color: white;
    display: flex;
    flex-shrink: 0;
    border-top: 1px solid #d9dcde;
  }

  .tab {
    flex-grow: 1;
    flex-basis: 0;
    color: #808b91;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    text-decoration: none;
    .svgicon {
      fill: #bfc5c8;
      margin-bottom: 4px;
    }
    &.router-link-active {
      background-color: #405159;
      color: white;
    }
  }

</style>